// TicketConfirmation: View ticket, resend email
import React from 'react';
import { Box, Typography, Button, Card, CardContent } from '@mui/material';

function TicketConfirmation() {
  return (
    <Box sx={{ maxWidth: 500, mx: 'auto', mt: 8 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Ticket Confirmation
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Your ticket has been confirmed. Please check your email for details.
          </Typography>
          <Button variant="contained" color="primary" sx={{ mb: 2 }}>Resend Email</Button>
          <Button variant="outlined" color="primary">View Ticket</Button>
        </CardContent>
      </Card>
    </Box>
  );
}

export default TicketConfirmation;
